// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a4a091e5","453":"7ace9fdf"}[chunkId] + ".chunk.js";
};